import React from 'react';
import './App.css';
import SentimentAnalyzer from './SentimentAnalyzer';

function App() {
    return (
        <div className="App">
            <SentimentAnalyzer />
        </div>
    );
}

export default App;
